module.exports = __webpack_public_path__ + "img/calendar-days-solid.801606b7.svg";